export const DEPT_LABEL = {
  architecture: "Architecture",
  "3d_visualisation": "3D Visualisation",
  construction: "Construction",
};

export const DEPT_LIST = [
  { key: "architecture", label: "Architecture", short: "Arch" },
  { key: "3d_visualisation", label: "3D Visualisation", short: "3D" },
  { key: "construction", label: "Construction", short: "Con" },
];

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  department_admin: "Department Admin",
  project_manager: "Project Manager",
  staff: "Staff",
  viewer: "Viewer",
};

export const PROJECT_FILTERS = [
  "All",
  "Architecture",
  "3D Visualisation",
  "Construction",
  "Residential",
  "Commercial",
  "Interior Design",
];

export const STATUS_FILTERS = ["Completed", "In Progress"];

export const SERVICE_OPTIONS = [
  "Architecture",
  "Building Plans",
  "3D Visualisation",
  "Construction",
  "Interior Design",
  "Full Design-Build Service",
  "General Enquiry",
];

export const ENQUIRY_STATUSES = [
  "New",
  "Contacted",
  "Consultation Scheduled",
  "Quotation Sent",
  "Converted",
  "Closed",
];

export function canManageContent(user) {
  return user && ["super_admin", "department_admin", "project_manager"].includes(user.role);
}

export function isSuperAdmin(user) {
  return user && user.role === "super_admin";
}

export function canAccessDept(user, dept) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  return (user.departments || []).includes(dept);
}
